<template>
  <a-popover
    trigger="hover"
    placement="bottomRight"
    :autoAdjustOverflow="true"
    :arrowPointAtCenter="true"
    overlayClassName="header-notice-wrapper"
    :visible="hovered"
    @visibleChange="handleHoverChange"
    :overlayStyle="{ width: '410px', top: '50px' }"
  >
    <template slot="content">
      <a-spin :spinning="loadding">
        <a-tabs class="noticeBox">
          <a-tab-pane :tab="'我的消息(' + pushCount + ')'" key="push">
            <a-list :dataSource="pushMessages">
              <a-list-item slot="renderItem" slot-scope="record">
                <div><a @click="openPush(record)">{{ record.title }}</a><p>{{ record.summary }}</p><small>{{ record.createTime }}</small></div>
              </a-list-item>
            </a-list>
            <a-button block @click="openPushList()">查看完整消息清单</a-button>
          </a-tab-pane>
          <a-tab-pane :tab="msg3Title" key="1">
            <a-list>
              <a-list-item :key="index" v-for="(record, index) in announcement3">
                <div style="margin-left: 5%; width: 100%" @click="onToJump(record)">
                  <p>
                    <a>{{ record.warnContent }}</a>
                  </p>
                  <div style="display: flex; justify-content: space-between">
                    <p style="color: rgba(0, 0, 0, 0.45); margin-bottom: 0px">{{ record.warnTime }}</p>
                    <div style="text-align: right;">
                      <a-tag color="blue"
                             style="max-width: 190px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                        {{ record.siteName }}
                      </a-tag>
                    </div>
                  </div>
                </div>
              </a-list-item>
              <div style="margin-top: 5px; text-align: center">
                <a-button @click="toMyAnnouncement(true)" type="dashed" block>查看更多</a-button>
              </div>
            </a-list>
          </a-tab-pane>
          <a-tab-pane :tab="msg1Title" key="2">
            <a-list>
              <a-list-item :key="index" v-for="(record, index) in announcement1">
                <div style="margin-left: 5%; width: 100%">
                  <p>
                    <a @click="showAnnouncement(record)">标题：{{ record.titile }}</a>
                  </p>
                  <div style="display: flex; justify-content: space-between">
                    <p style="color: rgba(0, 0, 0, 0.45); margin-bottom: 0px">{{ record.createTime }} 发布</p>
                    <div style="text-align: right">
                      <a-tag @click="showAnnouncement(record)" v-if="record.priority === 'L'" color="blue"
                      >一般消息
                      </a-tag>
                      <a-tag @click="showAnnouncement(record)" v-if="record.priority === 'M'" color="orange"
                      >重要消息
                      </a-tag>
                      <a-tag @click="showAnnouncement(record)" v-if="record.priority === 'H'" color="red"
                      >紧急消息
                      </a-tag>
                    </div>
                  </div>
                </div>
              </a-list-item>
              <div style="margin-top: 5px; text-align: center">
                <a-button @click="toMyAnnouncement()" type="dashed" block>查看更多</a-button>
              </div>
            </a-list>
          </a-tab-pane>
          <a-tab-pane :tab="msg2Title" key="3">
            <a-list>
              <a-list-item :key="index" v-for="(record, index) in announcement2">
                <div style="margin-left: 5%; width: 100%">
                  <p>
                    <a @click="showAnnouncement(record)">标题：{{ record.titile }}</a>
                  </p>
                  <div style="display: flex; justify-content: space-between">
                    <p style="color: rgba(0, 0, 0, 0.45); margin-bottom: 0px">{{ record.createTime }} 发布</p>
                    <div style="text-align: right">
                      <a-tag @click="showAnnouncement(record)" v-if="record.priority === 'L'" color="blue"
                      >一般消息
                      </a-tag>
                      <a-tag @click="showAnnouncement(record)" v-if="record.priority === 'M'" color="orange"
                      >重要消息
                      </a-tag>
                      <a-tag @click="showAnnouncement(record)" v-if="record.priority === 'H'" color="red"
                      >紧急消息
                      </a-tag>
                    </div>
                  </div>
                </div>
              </a-list-item>
              <div style="margin-top: 5px; text-align: center">
                <a-button @click="toMyAnnouncement()" type="dashed" block>查看更多</a-button>
              </div>
            </a-list>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </template>
    <span @click="fetchNotice" class="header-notice">
      <a-badge :count="msgTotal">
        <a-icon style="font-size: 16px; padding: 4px" type="bell" />
      </a-badge>
    </span>
    <push-message-detail ref="pushDetail" @read="loadPush" @business="openPushList" />
    <show-announcement ref="ShowAnnouncement" @ok="modalFormOk"></show-announcement>
    <warn-data-modal ref="warnDataModalRef"></warn-data-modal>
  </a-popover>
</template>

<script>
import { getAction, putAction } from '@/api/manage'
import ShowAnnouncement from './ShowAnnouncement'
import PushMessageDetail from '@/views/system/modules/PushMessageDetail'
import warnDataModal from '@/views/online/component/warnDataModal'

export default {
  name: 'HeaderNotice',
  components: {
    ShowAnnouncement,
    PushMessageDetail,
    warnDataModal
  },
  data() {
    return {
      loadding: false,
      pushMessages: [],pushCount: 0,
      url: {
        listCementByUser: '/sys/annountCement/listByUser',
        editCementSend: '/system/sysAnnouncementSend/editByAnntIdAndUserId',
        warnUrl: '/online/warn'
      },
      hovered: false,
      announcement1: [],
      announcement2: [],
      announcement3: [],
      msg1Count: '0',
      msg2Count: '0',
      msg3Count: '0',
      msg1Title: '通知公告',
      msg2Title: '系统消息',
      msg3Title: '预警消息',

    }
  },
  computed: {
    msgTotal() {
      return this.pushCount + parseInt(this.msg1Count) + parseInt(this.msg2Count) + parseInt(this.msg3Count)
    }
  },
  mounted() {
    console.log('headerNotice')
  },
  created() {
    this.loadDatas()
    this.noticeTimer = this.timer()
  },
  beforeDestroy() { clearInterval(this.noticeTimer) },
  methods: {
    onToJump(data) {
      console.log('onToJump', data)
      switch (data.category) {
        case '1':  //数据异常部分
          // this.modalObj.title = `${data.siteName}(${data.warnContent})`
          // this.modalObj.dataSource = [data]
          // this.modalObj.expandedRowKeys = [data.id]
          // this.modalObj.visible = true
          // this.columns = []
          // this.dataSource = []
          // if (data.msgId) {
          //   this.url = `/online/st${data.st}/cn2061`
          //   this.modalObj.st = data.st
          //   this.queryParam = { msgId: data.msgId, scopeId: data.siteId,scope:1 }
          //   this.getCol(data.st)
          //   this.loadData()
          // }
          this.$refs.warnDataModalRef.onToChangeData(data)
          break
      }
    },

    timer() {
      return setInterval(() => {
        this.loadDatas()
      }, 60000 * 30)
    },
    loadDatas() {
      try {
        // 获取系统消息
        getAction(this.url.listCementByUser + '?pageSize=5').then((res) => {
          if (res.success) {
            this.announcement1 = res.result.anntMsgList.reverse()
            this.msg1Count = res.result.anntMsgTotal
            this.msg1Title = '通知公告(' + res.result.anntMsgTotal + ')'
            this.announcement2 = res.result.sysMsgList.reverse()
            this.msg2Count = res.result.sysMsgTotal
            this.msg2Title = '系统消息(' + res.result.sysMsgTotal + ')'
          }
        })
      } catch (err) {
      }
      this.loadWarn()
      this.loadPush()
    },
    openPush(record) { this.$refs.pushDetail.open(record.id) },
    /** 快捷进入消息页时收起弹层和全局选择区，不沿用上一业务页布局。 */
    openPushList(message) {
      this.hovered = false
      this.$bus.$emit('showSite', 'show', false)
      this.$bus.$emit('showProject', 'show', false)
      this.$router.push({ path: '/sys/push/mine', query: message ? { businessId: message.id } : {} })
    },
    async loadPush() {
      try {
        const res=await getAction('/sys/push/messages/mine',{current:1,size:5,unread:true})
        if(res.success){this.pushMessages=res.result.records;this.pushCount=res.result.total}
      } catch(e) { this.pushMessages=[];this.pushCount=0 }
    },
    loadWarn() {
      // 获取系统消息
      getAction(this.url.warnUrl + '?order=desc&size=5&current=1&searchCount=false').then((res) => {
        if (res.success) {
          this.announcement3 = res.result.records.reverse()
          this.msg3Title = '预警消息'
          this.msg3Title = '预警消息(' + res.result.records.length + ')'
          this.msg3Count = res.result.records.length
        }
      })
    },
    fetchNotice() {
      if (this.loadding) {
        this.loadding = false
        return
      }
      this.loadding = true
      setTimeout(() => {
        this.loadding = false
      }, 200)
    },
    showAnnouncement(record) {
      putAction(this.url.editCementSend, { anntId: record.id }).then((res) => {
        if (res.success) {
          this.loadDatas()
        }
      })
      this.hovered = false
      this.$refs.ShowAnnouncement.detail(record)
    },
    toMyAnnouncement(flag) {
      if (flag) {
        this.$router.push('/online/WarnList')
        this.$bus.$emit('showSite', 'show', false)
      } else {
        this.$router.push({
          path: '/isps/userAnnouncement',
          name: 'isps-userAnnouncement'
        })
        this.$bus.$emit('showSite', 'show', false)
      }

      this.$bus.$emit('showProject', 'show', false)
    },

    modalFormOk() {
    },
    handleHoverChange(visible) {
      this.hovered = visible
    }
  }
}
</script>

<style lang="css">
.header-notice-wrapper {
  top: 50px !important;
}

.noticeBox {
  color: #000 !important;
}
</style>
<style lang="scss" scoped>
.header-notice {
  display: inline-block;
  transition: all 0.3s;

  .anticon {
    font-size: 1.3rem !important;
    color: aqua;
  }

  span {
    vertical-align: initial;
  }
}


</style>
